<template>

    <div>
        <div v-for="(section,index) in sections">
            <div v-if="section.tag === 'introduction' && section.text">
                <preview-introduction :token="token" :section="section" :tempSection="tempSection" :page="index"></preview-introduction>
                <br clear="all">
            </div>

            <div v-else-if="section.tag === 'terms-and-conditions' && section.text">
                <preview-terms-and-conditions :token="token" :section="section" :tempSection="tempSection" :page="index"></preview-terms-and-conditions>
                <br clear="all">
            </div>


            <div v-else-if="section.tag === 'inspection' && section.InspectionSubsections.length > 0">
                <preview-inspections :token="token" :section="section" :tempSection="tempSection" :page="pageNumber"></preview-inspections>
                <br clear="all">
            </div>

            <div v-else-if="section.tag === 'title'">
                <!--<preview-title :token="token" :section="section" :tempSection="tempSection"></preview-title>-->
                <div class="p-0 m-0" v-if="proposal.cover_template == 1">
                    <proposal-generator-cover-1 :section="section" :proposal="proposal" :team="team"></proposal-generator-cover-1>
                </div>
                <div class="p-0 m-0" v-else-if="proposal.cover_template == 2">
                    <proposal-generator-cover-2 :section="section" :proposal="proposal" :team="team"></proposal-generator-cover-2>
                </div>
                <div class="p-0 m-0" v-else-if="proposal.cover_template == 3">
                    <proposal-generator-cover-3 :section="section" :proposal="proposal" :team="team"></proposal-generator-cover-3>
                </div>
                <div class="p-0 m-0" v-else-if="proposal.cover_template == 4">
                    <proposal-generator-cover-4 :section="section" :proposal="proposal" :team="team"></proposal-generator-cover-4>
                </div>
                <br clear="all">
            </div>

            <div v-else>
                <div v-if="section.tag !== 'inspection'">
                    <div v-if="section.text !== null || section.url !== null">
                        <preview-custom :token="token" :section="section" :tempSection="tempSection" :page="index"></preview-custom>
                        <br clear="all">
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
<style>
.one-page{
    min-height: 1000px;
    position:relative;
}
.proposal-footer{
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
}
.page-number{
    background: #fff;
    padding: 5px 15px;
    border-radius: 5px;
    position: absolute;
    bottom: 15px;
    right: 15px;
    box-shadow: 0px 0px 1px 1px #444;
    z-index: 999;
}
.one-page table {
    border-collapse: collapse;
    margin: 0;
    width: 100%;
    table-layout: fixed;
    word-break: break-word;
}
.one-page table, .one-page th, .one-page td{
    border:1px solid #b9b9b9;
    padding: 2px 5px;
}
.one-page th{
    text-align: center !important;
    background-color: #f0f0f0;
}
@media print {
    @page {
        margin: 0cm !important;
    }
}
</style>
<script>

import axios                     from 'axios';
import PreviewTermsAndConditions from "./preview-terms-and-conditions";
import PreviewInspections        from "./preview-inspections";
import PreviewTitle              from "./preview-title";
import PreviewCustom             from "./preview-custom";
import PreviewIntroduction       from "./preview-introduction";
import ProposalGeneratorCover1 from "../cover-templates/proposal-generator-cover-1";

export default {
    components: {
        ProposalGeneratorCover1,
        PreviewCustom, PreviewTitle, PreviewInspections, PreviewTermsAndConditions, PreviewIntroduction},
    props: ['token','proposal','team'],
    name: "preview",
    data() {
        return {
            tempSectionCheck:[],
            tempSection: '',
            sections: '',
        }
    },
    mounted() {
        this.loadSections();
    },
    methods: {
        loadSections() {
            let self = this;
            axios.get(route('proposal.load-preview', {token:self.token}))
                .then(function ({data}) {
                    self.tempSection = data;
                    self.sections = Object.values(data.sections);
                })
        }
    }

}
</script>
